var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('ul', {
    staticClass: "step-container"
  }, _vm._l(_vm.steps, function (item, index) {
    return _c('li', {
      key: index,
      class: {
        done: index <= _vm.current
      }
    }, [_c('div', {
      staticClass: "step-item"
    }, [index !== 0 ? _c('div', {
      staticClass: "line"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "circle"
    }, [_vm._v("\n          " + _vm._s(index + 1) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n          " + _vm._s(_vm.$t(("createSellerAccount.steps." + item))) + "\n        ")])])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }